module.exports = __webpack_public_path__ + "static/img/default_img.3abadd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default_img.png
// module id = wHAY
// module chunks = 1